import type { FaireProductEntity } from "../../entity_types/product";

export const p_ej58bmvmjx: FaireProductEntity = {
  token: "p_ej58bmvmjx",
  type: "product",
  name: "RARE Oreo X Cadbury Ganges Blue -  INDIA (15 COUNT)",
  brandToken: "b_pdahr8yenn",
  brandName: "Exotic Snacks Wholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/a4d6afd6427b4e8258c9f107dfeb5820e73ea022bdda94141e5c5883082e8b57.jpeg",
  galleryImageUrls: [],
  priceDollars: 76.21,
  description:
    "Flavor Distribution brings you the RARE Oreo X Cadbury Ganges Blue from India. This exclusive snack is a product of our expertise in distributing exotic snacks in America. Each pack contains 15 delicious cookies. Our prices are firm because our product freshness is guaranteed. We offer both warehouse pickup and nationwide shipping for your convenience.",
  tags: [],
  msrpDollars: 152.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:30.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
